export default __webpack_public_path__ + "static/media/2_long.27317ac6.svg";